<script lang="ts">
  import Arrow from '../../../assets/svgs/arrow.svelte';

  export let direction: string = 'left';
  export let title: string = direction == 'left' ? 'Previous' : 'Next';
  export let arrowStyle: string = '';
</script>

<button
  on:click
  class="w-12 h-12 bg-white bg-opacity-90 rounded-full border border-gray-200 justify-center items-center gap-3 inline-flex {arrowStyle}"
  {title}
>
  <Arrow {direction} />
</button>
